import { Navigate, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ContractsSettingPageQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import WorkConditions from 'modules/contracts_settings/components/WorkConditions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const WorkingConditionsRootPage = () => {
  const { data, loading, error } = useOutletContext<{
    data: ContractsSettingPageQuery
    loading: boolean
    error: unknown
  }>()

  const { navigation } = useNavigation()

  const enabledWorkConditions =
    data?.features?.featuresConnection.nodes.some(
      (el) => el.name === 'dev_timeoff_work_conditions' && el.enabled
    ) ?? false

  if (!loading && !enabledWorkConditions) {
    const rootPage = navigation.settings.contracts_settings.fullPath()
    return <Navigate to={rootPage} />
  }

  const groups = data?.workingConditions.versionsConnection.nodes || []

  return (
    <ResponsivePage.Body variant="wide" showHeader={false} loading={loading} error={error}>
      <Box gap="s32" width="full" gapDivider>
        <WorkConditions groups={groups} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default WorkingConditionsRootPage
